
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const TestTTDSevakForm = () => {
  const [formData, setFormData] = useState({
    idProofType: "",
    idProofNumber: "",
    name: "",
    surname: "",
    fatherSpouseName: "",
    dob: "",
    age: "",
    mobile: "",
    email: "",
    bloodGroup: "",
    gender: "",
    fitness: "",
    qualification: "",
    profession: "",
    designation: "",
    specialization: "",
    placeOfWork: "",
    country: "",
    state: "",
    district: "",
    city: "",
    street: "",
    doorNumber: "",
    pincode: "",
    nearestTemple: "",
    profilePhoto: null
  });

  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.size <= 1024 * 1024) { // 1MB limit
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
        setFormData({ ...formData, profilePhoto: reader.result });
      };
      reader.readAsDataURL(file);
    } else {
      alert("File size should be less than 1MB");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const existingData = JSON.parse(localStorage.getItem("sevakData")) || [];
    existingData.push(formData);
    localStorage.setItem("sevakData", JSON.stringify(existingData));
    alert("Data saved successfully!");
    setFormData({
      idProofType: "",
      idProofNumber: "",
      name: "",
      surname: "",
      fatherSpouseName: "",
      dob: "",
      age: "",
      mobile: "",
      email: "",
      bloodGroup: "",
      gender: "",
      fitness: "",
      qualification: "",
      profession: "",
      designation: "",
      specialization: "",
      placeOfWork: "",
      country: "",
      state: "",
      district: "",
      city: "",
      street: "",
      doorNumber: "",
      pincode: "",
      nearestTemple: "",
      profilePhoto: null
    });
    setPreview(null);
  };

  return (
    <div className="container mt-4 custom-form">
      <h2 className="mb-4 text-center">Sevak Registration Form</h2>
      <form onSubmit={handleSubmit} className="needs-validation" noValidate>
        
        {/* Profile Photo Upload */}
        <div className="card mb-3">
          <div className="card-header">Profile Photo</div>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="profilePhoto" className="form-label">Upload Photo (Max 1MB)</label>
              <input
                type="file"
                id="profilePhoto"
                name="profilePhoto"
                accept="image/*"
                className="form-control existing-class custom-input"
                onChange={handlePhotoUpload}
              />
            </div>
            {preview && (
              <div className="text-center">
                <img src={preview} alt="Preview" className="img-thumbnail" style={{ width: "150px", height: "150px" }} />
              </div>
            )}
          </div>
        </div>

        {/* Identity Proof */}
        <div className="card mb-3">
          <div className="card-header">Identity Proof</div>
          <div className="card-body row">
            <div className="col-md-6 mb-3">
              <label htmlFor="idProofType" className="form-label">ID Proof Type *</label>
              <select
                id="idProofType"
                name="idProofType"
                className="form-select existing-class custom-input"
                value={formData.idProofType}
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="Aadhar">Aadhar</option>
                <option value="Passport">Passport</option>
                <option value="Voter ID">Voter ID</option>
              </select>
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="idProofNumber" className="form-label">ID Proof Number *</label>
              <input
                type="text"
                id="idProofNumber"
                name="idProofNumber"
                className="form-control existing-class custom-input"
                value={formData.idProofNumber}
                onChange={handleChange}
                required
              />
            </div>
          </div>
        </div>

        {/* Basic Details */}
        <div className="card mb-3">
          <div className="card-header">Basic Details</div>
          <div className="card-body row">
            {/* Name */}
            <div className="col-md-6 mb-3">
              <label htmlFor="name" className="form-label">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                className="form-control existing-class custom-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            {/* Surname */}
            <div className="col-md-6 mb-3">
              <label htmlFor="surname" className="form-label">Surname</label>
              <input
                type="text"
                id="surname"
                name="surname"
                className="form-control existing-class custom-input"
                value={formData.surname}
                onChange={handleChange}
              />
            </div>
            {/* Father/Spouse */}
            <div className="col-md-6 mb-3">
              <label htmlFor="fatherSpouseName" className="form-label">Father/Spouse Name</label>
              <input
                type="text"
                id="fatherSpouseName"
                name="fatherSpouseName"
                className="form-control existing-class custom-input"
                value={formData.fatherSpouseName}
                onChange={handleChange}
              />
            </div>
            {/* DOB */}
            <div className="col-md-6 mb-3">
              <label htmlFor="dob" className="form-label">Date of Birth *</label>
              <input
                type="date"
                id="dob"
                name="dob"
                className="form-control existing-class custom-input"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>
            {/* Age */}
            <div className="col-md-6 mb-3">
              <label htmlFor="age" className="form-label">Age *</label>
              <input
                type="number"
                id="age"
                name="age"
                className="form-control existing-class custom-input"
                value={formData.age}
                onChange={handleChange}
                required
              />
            </div>
            {/* Mobile */}
            <div className="col-md-6 mb-3">
              <label htmlFor="mobile" className="form-label">Mobile Number *</label>
              <input
                type="tel"
                id="mobile"
                name="mobile"
                className="form-control existing-class custom-input"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </div>
            {/* Email */}
            <div className="col-md-6 mb-3">
              <label htmlFor="email" className="form-label">Email Id *</label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control existing-class custom-input"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            {/* Blood Group */}
            <div className="col-md-6 mb-3">
              <label htmlFor="bloodGroup" className="form-label">Blood Group</label>
              <select
                id="bloodGroup"
                name="bloodGroup"
                className="form-select existing-class custom-input"
                value={formData.bloodGroup}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="A+">A+</option>
                <option value="B+">B+</option>
                <option value="O+">O+</option>
              </select>
            </div>
            {/* Gender */}
            <div className="col-md-6 mb-3">
              <label className="form-label">Gender *</label>
              <div className="d-flex">
                <div className="form-check me-3">
                  <input
                    type="radio"
                    id="genderMale"
                    name="gender"
                    value="Male"
                    className="form-check-input existing-class"
                    checked={formData.gender === "Male"}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="genderMale" className="form-check-label">Male</label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    id="genderFemale"
                    name="gender"
                    value="Female"
                    className="form-check-input existing-class"
                    checked={formData.gender === "Female"}
                    onChange={handleChange}
                  />
                  <label htmlFor="genderFemale" className="form-check-label">Female</label>
                </div>
              </div>
            </div>
            {/* Fitness */}
            <div className="col-md-6 mb-3">
              <label htmlFor="fitness" className="form-label">Fitness *</label>
              <select
                id="fitness"
                name="fitness"
                className="form-select existing-class custom-input"
                value={formData.fitness}
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option value="Mentally Fit">Mentally Fit</option>
                <option value="Physically Fit">Physically Fit</option>
              </select>
            </div>
          </div>
        </div>

        {/* Profession & Education */}
        <div className="card mb-3">
          <div className="card-header">Profession & Education Details</div>
          <div className="card-body row">
            {["qualification", "profession", "designation", "specialization", "placeOfWork"].map((field, idx) => (
              <div className="col-md-6 mb-3" key={idx}>
                <label htmlFor={field} className="form-label">
                  {field === "designation" ? "Designation / Retired as" :
                   field === "specialization" ? "Specialisation/Skill" :
                   field === "placeOfWork" ? "Place of Working/Related" :
                   field.charAt(0).toUpperCase() + field.slice(1)}
                </label>
                <input
                  type="text"
                  id={field}
                  name={field}
                  className="form-control existing-class custom-input"
                  value={formData[field]}
                  onChange={handleChange}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Address Details */}
        <div className="card mb-3">
          <div className="card-header">Address Details</div>
          <div className="card-body row">
            {[
              { name: "country", type: "select", options: ["India"] },
              { name: "state", type: "text" },
              { name: "district", type: "text" },
              { name: "city", type: "text" },
              { name: "street", type: "text" },
              { name: "doorNumber", type: "text" },
              { name: "pincode", type: "text" },
              { name: "nearestTemple", type: "text" }
            ].map((field, idx) => (
              <div className="col-md-6 mb-3" key={idx}>
                <label htmlFor={field.name} className="form-label">
                  {field.name.charAt(0).toUpperCase() + field.name.slice(1)} *
                </label>
                {field.type === "select" ? (
                  <select
                    id={field.name}
                    name={field.name}
                    className="form-select existing-class custom-input"
                    value={formData[field.name]}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select</option>
                    {field.options.map((opt, i) => (
                      <option key={i} value={opt}>{opt}</option>
                    ))}
                  </select>
                ) : (
                  <input
                    type="text"
                    id={field.name}
                    name={field.name}
                    className="form-control existing-class custom-input"
                    value={formData[field.name]}
                    onChange={handleChange}
                    required
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary px-4">Save and Add Sevak</button>
        </div>
      </form>
    </div>
  );
};

export default TestTTDSevakForm;
